import type { HotkeyActionId } from '@/shared/lib/hotkeys';
import type { ReportWindowType } from '@/shared/lib/windows';

/** Пункт бокового меню владельца: путь внутри магазина, подпись и действие из каталога клавиш
 *  (`Alt+цифра` — переход, `Alt+Shift+цифра` — окно отчёта). */
export interface NavLeaf {
  path: string;
  label: string;
  action: HotkeyActionId;
  /** Пункт открывает плавающее окно отчёта, а не страницу. */
  report?: ReportWindowType;
}

export const REFERENCE_NAV: NavLeaf[] = [
  { path: '/categories', label: 'Категории', action: 'nav.categories' },
  { path: '/counterparties', label: 'Контрагенты', action: 'nav.counterparties' },
];

export const DOCUMENT_NAV: NavLeaf[] = [
  { path: '/purchases', label: 'Приходы', action: 'nav.purchases' },
  { path: '/sales', label: 'Продажи', action: 'nav.sales' },
  { path: '/returns-in', label: 'Возвраты от клиентов', action: 'nav.returnsIn' },
  { path: '/returns-out', label: 'Возвраты поставщикам', action: 'nav.returnsOut' },
  { path: '/write-offs', label: 'Списания', action: 'nav.writeOffs' },
  { path: '/inventories', label: 'Инвентаризации', action: 'nav.inventories' },
  { path: '/cash-orders', label: 'Кассовые ордера', action: 'nav.cashOrders' },
];

export const REQUEST_NAV: NavLeaf[] = [
  { path: '/order-requests', label: 'Заявки на товар', action: 'nav.orderRequests' },
  { path: '/join-requests', label: 'Заявки на подключение', action: 'nav.joinRequests' },
];

// §1, §1.8: клик открывает плавающее окно отчётов (не навигацию) — двигается, растягивается,
// внутри само переключается между всеми 9 отчётами. `/reports/*`-маршруты остаются в роутере
// только для прямых ссылок.
export const REPORT_NAV: NavLeaf[] = [
  { path: '/reports/stock', label: 'Остатки', action: 'nav.report1', report: 'stock' },
  { path: '/reports/turnover', label: 'Обороты', action: 'nav.report2', report: 'turnover' },
  { path: '/reports/sales', label: 'Продажи', action: 'nav.report3', report: 'sales' },
  { path: '/reports/profit', label: 'Прибыль', action: 'nav.report4', report: 'profit' },
  { path: '/reports/write-offs', label: 'Списания', action: 'nav.report5', report: 'write-offs' },
  { path: '/reports/debts', label: 'Долги', action: 'nav.report6', report: 'debts' },
  { path: '/reports/expiry', label: 'Сроки годности', action: 'nav.report7', report: 'expiry' },
  { path: '/reports/negative-stock', label: 'Товары в минусе', action: 'nav.report8', report: 'negative-stock' },
  { path: '/reports/provisional-sales', label: 'Предварительная себестоимость', action: 'nav.report9', report: 'provisional-sales' },
];

export const SINGLE_NAV: NavLeaf[] = [
  { path: '/audit-log', label: 'Журнал', action: 'nav.auditLog' },
  { path: '/settings', label: 'Настройки', action: 'nav.settings' },
];

/** Все пункты меню: из них строятся и само меню, и глобальные клавиши перехода. */
export const ALL_NAV: NavLeaf[] = [...REFERENCE_NAV, ...DOCUMENT_NAV, ...REQUEST_NAV, ...REPORT_NAV, ...SINGLE_NAV];
